<template>
    <div class="container-lg">
        <div class="card pt-5">
            <div class="body">
                <notifications group="errors" />
                <div class="row">
                    <div class="col-lg-5 col-sm-12">
                        <div class="card mb-3">
                            <div class="p-3">
                                <h2>
                                    Actualización: {{this.$Params.tituloPortal}}
                                </h2>
                                <div class="h5 py-3">Esta página sirve para actualizar el Portal a la versión más reciente. Al clickar sobre el botón se ejecutará el proceso de actualitzación automáticamente que puede tardar pocos segundos. Se mostrará el progreso por pantalla, y cuando haya terminado aparecerá un mensaje final.</div>

                                <div class="btn-warning" v-if="updatorInfo.configured != 'Instalado'">
                                    <p>El sistema de actualización del portal no está configurado correctamente</p>
                                </div>
                                <p>Versión instalada: {{updatorInfo.version}}</p>
                                <p>Versión disponible: {{updatorInfo.availableVersion}}</p>

                                <div v-if="updatorInfo.configured == 'Instalado'">
                                    <a id="btnUpdate" href="#" class="btn btn-primary" v-on:click.prevent="updatePortal">Actualizar Portal</a>
                                    <a id="btnBackup" href="#" class="btn btn-primary" v-on:click.prevent="backup">Restaurar backup</a>
                                </div>
                                <div class="pt-2">
                                    <router-link to="start">Volver</router-link>
                                </div>
                            </div>
                        </div>

                    </div>
                    <div class="col-lg-7 col-sm-12">
                        <div>
                            <img :src="this.$Params.urlBase + 'img/signin.png'" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
    .card-border {
        border: 1px solid #00000020;
    }
</style>

<script>
    import { adminService } from '../api/admin';
    import { cookie } from '@/_utils/cookie'
    import Vue from 'vue'
    export default {
        name: 'Admin',
        data() {
                return {
                    updatorInfo: [],
                    version: '',
                    availableVersion: '',
                    configured: '',
                    updated: true,
                }
        },
        methods: {
            async updatePortal()
            {
                if(await adminService.updatePortal(''))
                    window.location.href = Vue.prototype.$Params.urlBase + "update.html"
            },
            async backup()
            {
                if(await adminService.updatePortal('BACKUP'))
                    window.location.href = Vue.prototype.$Params.urlBase + "update.html"
            }
        },
        async created() {
            document.body.classList.add('admin-panel');
            
            if(this.$route.query.upd != undefined)
                cookie.setToken(this.$route.query.upd);

            this.updatorInfo = adminService.updateInfo();
            this.updated = (this.updatorInfo.version == this.updatorInfo.availableVersion);
            this.$i18n.locale = 'es';

            if(this.$route.query.upd != undefined)
                this.updatePortal();   
        },
    }

</script>